<template>
    <div class="box">
        <div class="tabbar" v-if="tabbarShow" :class="navBarFixed ? 'navBarFixed' : ''">
            <img @click="goback" src="../../../../static/common/logoBlack.png" alt="" />
            <div class="downloads" @click="downloads">
                下载APP
            </div>
        </div>
        <img class="banner" src="/activity/Millionsubsidy/banner.png" alt="" />
        <img class="wapbanner" src="/activity/Millionsubsidy/wap/banner.png" alt="" />
        <div :class="navBarFixed ? 'activity-tit activitys' : isApp ?'activity-tit titss': 'activity-tit'">
            活动时间： 即日起一{{ getLastDayOfMonth() }}


        </div>
        <div id="login" ref="targetTops">

            <div class="interactive">
                <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号" @blur="changePhone" />
                <div class="codeBox">
                    <input v-model="form.code" type="text" placeholder="请输入验证码" />
                    <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                    <span v-else>重新获取({{ verSecond }})</span>
                </div>

                <div class="buttom" @click="submit(form)">
                    <img src="/activity/Millionsubsidy/button.png" alt="">
                </div>
            </div>
            <div v-if="controlImgCodeDialog" class="codeDialog">
                <img :src="imgcodelocal" alt="" />
                <p>
                    <span>图形验证码:</span>
                    <input type="text" v-model="form.codeNumber" />
                </p>
                <div>
                    <button @click="() => {
                        this.controlImgCodeDialog = false;
                    }
                    ">
                        取消
                    </button>
                    <button @click="confirm(form.codeNumber)">确定</button>
                </div>
            </div>

        </div>
        <div :class="navBarFixed ? 'waplogin logins' : isApp ?'waplogin waplogin1': 'waplogin'" ref="targetTops">

            <div class="interactive">
                <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号" @blur="changePhone" />
                <div class="codeBox">
                    <input v-model="form.code" type="text" placeholder="请输入验证码" />
                    <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                    <span v-else>重新获取({{ verSecond }})</span>
                </div>

                <div class="buttom" @click="submit(form)">
                    <img src="/activity/Millionsubsidy/wap/button.png" alt="">
                </div>
            </div>
            <div v-if="controlImgCodeDialog" class="codeDialog">
                <img :src="imgcodelocal" alt="" />
                <p>
                    <span>图形验证码:</span>
                    <input type="text" v-model="form.codeNumber" />
                </p>
                <div>
                    <button @click="() => {
                        this.controlImgCodeDialog = false;
                    }
                    ">
                        取消
                    </button>
                    <button @click="confirm(form.codeNumber)">确定</button>
                </div>
            </div>

        </div>

        <div class="content">
            <div class="part">
                <div class="part1">
                    <div class="rule" @click="showDialogs">
                        <img src="/activity/Millionsubsidy/rule.png" alt="">

                    </div>
                    <img src="/activity/Millionsubsidy/cart.png" alt="">

                </div>
                <div class="part1-buttom">
                    <img class="request" @click="live800" src="/activity/Millionsubsidy/request.png" alt="">
                    <img src="/activity/Millionsubsidy/button2.png" @click="tosCroll" alt="">

                </div>
                <div class="part2 clearfix">
                    <div class="rule" @click="showDialogs1">
                        <img src="/activity/Millionsubsidy/rule.png" alt="">

                    </div>
                    <img src="/activity/Millionsubsidy/cart1.png" alt="">

                </div>
                <div class="part2-buttom" @click="tosCroll">
                    <img src="/activity/Millionsubsidy/join.png" alt="">


                </div>
                <div class="part3">
                    <img src="/activity/Millionsubsidy/cart2.png" alt="">

                </div>
            </div>
            <contactus-vue></contactus-vue>

        </div>
        <div class="wapcontent">
            <div class="part">
                <div class="part1">
                    <div class="rule" @click="showDialogs">
                        <img src="/activity/Millionsubsidy/wap/rule.png" alt="">

                    </div>
                    <img src="/activity/Millionsubsidy/wap/cart.png" alt="">

                </div>
                <div class="part1-buttom">
                    <img class="request" @click="live800" src="/activity/Millionsubsidy/wap/request.png" alt="">
                    <img src="/activity/Millionsubsidy/wap/button2.png" @click="tosCroll" alt="">

                </div>
                <div class="part2 clearfix">
                    <div class="rule" @click="showDialogs1">
                        <img src="/activity/Millionsubsidy/wap/rule.png" alt="">

                    </div>
                    <img src="/activity/Millionsubsidy/wap/cart1.png" alt="">

                </div>
                <div class="part2-buttom" @click="tosCroll">
                    <img style="width: 100%;" src="/activity/Millionsubsidy/wap/join.png" alt="">


                </div>
                <div class="part3">
                    <img src="/activity/Millionsubsidy/wap/cart2.png" alt="">

                </div>
            </div>
        </div>

        <el-dialog :visible.sync="showDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs1">
            <div class="loginDialogs1">


                <img class="closer" @click="showDialog = false" src="/activity/Millionsubsidy/close.png" alt="" />
                <ul class="dialogContent" id="number">
                    <h3></h3>
                    <li>
                        <span>活动时间：</span>
                        即日起一{{ getLastDayOfMonth() }}
                    </li>
                    <li>
                        <span>活动对象：</span>
                        活动期间，在本平台首次入金的客户
                    </li>
                    <li>活动期间，新用户可享双重福利：</li>
                    <li><span>百万补贴第一弹：首入金送赠金，最高领$100，000赠金</span></li>
                    <li> 1、首次充值24小时内，充多少送多少赠金； </li>

                    <li>
                        2、赠金有效期90天，有效期内每交易一手伦敦金/伦敦银，获得相对应的赠金金额（未满一手按照
                        实际交易手数占一手的比例计算）。

                    </li>
                    <li>
                        <div class="tabs">
                            <table style="border-collapse:collapse;">
                                <tr class="biaoti">
                                    <th>层级</th>
                                    <th>月交易量</th>
                                    <th>每手释放</th>
                                    <th>有效期</th>

                                </tr>


                                <tr class="bodys">
                                    <th>
                                        1
                                    </th>
                                    <th>
                                        0.01-10手
                                    </th>
                                    <th>
                                        $2/手
                                    </th>
                                    <th rowspan="4">
                                        90天
                                    </th>
                                </tr>
                                <tr class="bodys">
                                    <th>
                                        2
                                    </th>
                                    <th>
                                        10.01-30手
                                    </th>
                                    <th>
                                        $3/手
                                    </th>

                                </tr>
                                <tr class="bodys">
                                    <th>
                                        3
                                    </th>
                                    <th>
                                        30.01-50手

                                    </th>
                                    <th>
                                        $4/手
                                    </th>

                                </tr>
                                <tr class="bodys">
                                    <th>
                                        4
                                    </th>
                                    <th>
                                        50.01手及以上
                                    </th>
                                    <th>
                                        $5/手
                                    </th>

                                </tr>



                            </table>
                        </div>

                    </li>
                    <li>
                        3、可登录<span class="font">App-我的-赠金奖励</span>中查看奖励详情。<br />
                        4、美元赠金按交易手数返还，当月交易越多，每手返还越高！<br />
                        更多活动详情，请下载App-我的-赠金奖励中查看，或咨询客服。<br />
                        <span class="example">
                            举例：A客户，首次入金$300，随后24h内再充$200，获得$500赠金。在当月结算时，A客户积极
                            交易32手，累计获得$78=2*10+3*20+2*4。
                        </span>

                    </li>
                    <li id="numbersecond">
                        <span>百万补贴第二弹：独家保障！限时7日亏损全险</span><br />
                        新人首入后7天内享平台补贴，有效期内累计交易亏损达到交易补贴额度，即可获得对应现金<br />

                    </li>
                    <li>

                        <div class="tabs">
                            <table style="border-collapse:collapse;">
                                <tr class="biaoti">
                                    <th>层级</th>
                                    <th>7日亏损</th>
                                    <th>交易补贴额度</th>

                                </tr>


                                <tr class="bodys">
                                    <th>
                                        L1
                                    </th>
                                    <th>
                                        ≥$100
                                    </th>
                                    <th>
                                        $50现金+$50赠金
                                    </th>

                                </tr>
                                <tr class="bodys">
                                    <th>
                                        L2
                                    </th>
                                    <th>
                                        ≥$1000
                                    </th>
                                    <th>
                                        $500现金+$500赠金
                                    </th>

                                </tr>
                                <tr class="bodys">
                                    <th>
                                        L3
                                    </th>
                                    <th>
                                        ≥$10000
                                    </th>
                                    <th>
                                        $5000现金+$5000赠金
                                    </th>

                                </tr>




                            </table>
                        </div>

                    </li>
                    <li>
                        1.补贴获得的现金和赠金，7日后达标自动打入账户余额。<br />
                        2.得到的现金可当真实资金使用，可交易可提现，提现时无手数要求。<br />
                        3.补贴仅能获得一次，无法重复获取。<br />
                        <span class="example">
                            举例：A客户，首次入金$300，在之后的7天内，A客户积极
                            交易，但行情不佳，亏损105美元，那么A客户账户获得$50
                            现金+$50赠金。
                        </span>


                    </li>
                    <li>
                        <span>注意事项：</span><br />
                        1.客户参与活动需在本公司开立真实交易账户；参与该活动
                        的新用户，为保证资金安全，在初始L1层级，账户强平比
                        例上调至50%，升级后自动恢复为20%<br />
                        2.交易手数计算：开仓一手平仓一手，如此来回算一手；<br />
                        3.本活动本公司新客户仅有一次机会参与，不可重复领取；<br />
                        4.为交易环境的公平性与真实性，禁止在单一账户或多账户
                        对任一交易品种实施多空双向对冲锁仓操作（即同时持有相
                        反方向仓位），蓄意违反者，平台将取消其活动参与资格，
                        平台对于此情况的判断，拥有最终解释权。<br />
                        5.本公司保留随时修订、暂停、终止本活动及任何相关规则
                        条款之权利及其解释权。

                    </li>
                </ul>
            </div>
        </el-dialog>
        <div class="dark" v-if="showDialog" @click="showDialog = false"></div>
        <!-- 登录注册 -->
        <el-dialog :visible.sync="loginDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs">
            <div class="loginDialogs">
                <img class="closer" @click="loginDialog = false" src="/activity/Millionsubsidy/close.png" alt="" />
                <img class="success" src="/activity/Millionsubsidy/success.png" alt="">
                <div class="conts">
                    <span>您的账号：{{ account }}</span><br />
                    <span>密码：{{ password }}</span>
                </div>
                <div class="buttoms">
                    <img @click="toActivity" v-if="isApp" src="/activity/Millionsubsidy/wap/activity.png" alt="">
                    <img @click="downloadApp" v-else src="/activity/Millionsubsidy/download.png" alt="">
                    <img @click="loginDialog = false" src="/activity/Millionsubsidy/button1.png" alt="">

                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { verifyImgCode, quickRegister } from '../../../../api/info'
import ContactusVue from "../../Contactus.vue";
import { queryConfigValue, getFakebonus } from '@/apis/common';
import userSign from '@/mixins/userSign';
import { mapState, mapActions } from "vuex";
import { setToken, getToken, deleteToken } from "../../../../utils/cookies.js";

export default {
    components: {
        ContactusVue

    },
    mixins: [userSign],
    data() {
        return {

            navBarFixed: false,
            scroll: "",
            screenWidth: null,
            slider: true,
            showDialog: false,
            formattedDateString: '',
            timer: null,
            qrCodeUrl: '',
            loginDialog: false,//注册成功弹框
            account: '',//账号
            password: '',//密码
            isApp: false,//是否App进入 
            form: {
                phone: '',
                code: '',
                codeNumber: '',
            },
            tabbarShow: true,
            isApp:false
        };
    },

    mounted() {
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };


    },
    destroyed() {

    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                // this.$router.push({
                //     name: "sc_2024wap",
                //     query: this.$route.query || {},
                // });
            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);
        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.tabbarShow = false

            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)

        }

        else {

        }

    },
    methods: {
        // 下载APP
        downloads(){
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
                try {
                    window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
                } catch (error) {
                    window.open('https://apps.apple.com/cn/app/id1598072476');
                }
            } else { // 安卓
                try {
                    window.android.gotoRegisterReal();
                } catch (error) {
                    window.open('https://oss.0790jiaxiao.com/HS/software/hs_9999.apk');
                }
            } 
        },
        getLastDayOfMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const lastDayOfMonth = new Date(year, month, 0);
            // 获取最后一天的日期
            const lastDate = lastDayOfMonth.getDate();
            return month + '月' + lastDate + '日'
        },
        confirm(attr) {
            if (attr) {
                let data = {
                    Mobile: this.form.phone,
                    Token: this.guid,
                    ImgCode: Number(attr),
                }
                // 获取图片验证码接口
                verifyImgCode(data).then(res => {
                    if (res.IsSuccess) {
                        this.$message({
                            message: res.Data,
                            type: 'success'
                        });
                        // this.form.code = res.data;
                        this.verControl = !this.verControl;
                        this.controlImgCodeDialog = false;
                    } else {
                        this.$message({
                            message: res.Data,
                            type: 'warning',
                        });
                        this.controlImgCodeDialog = false;
                    }
                })
            } else {
                this.$message({
                    message: '请输入图片验证码结果!',
                    type: 'warning'
                });
            }
        },
        // 前往活动
        toActivity() {
            if (this.$route.query) {
                if (this.$route.query.accessKey) {
                    window.open(window.location.origin + '/activity/MillionsubsidyDetail/index')
                } else {
                    // 在安卓app
                    if (window.android) {
                        window.android.gotoLogin();
                        return
                    }
                    // 在ios
                    if (window.webkit) {
                        window.webkit.messageHandlers.gotoLogin()
                        return
                    }
                }
            }
        },
        showDialogs() {
            this.showDialog = true          
        },
        showDialogs1() {
            console.log('111111111111111')

            this.showDialog = true     
           
          
        },


        // 点击获取焦点
        focusInput() {
            this.$refs.inputElement.focus();
        },

        // 返回上级页面
        goback() {
            window.location.href = window.location.origin;
        },
        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 90) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }
        },
        // 提交手机号验证码
        submit(form) {
            if (form.phone && form.code) {
                this.handleRegister().then((res) => {
                    console.log('注册信息------', res)
                    this.loginDialog = true

                    localStorage.setItem('token', res.Token);
                    localStorage.setItem('account', res.account);
                    this.account = res.account
                    this.password = res.password
                }).catch(() => {
                })
            } else {
                this.$message({
                    message: '请输入手机号和验证码！',
                    type: 'warning',
                });
            }
        },
        // 回到顶部
        toTop() {
            document.documentElement.scrollTop = 0;
        },
        // 跳转到登录注册
        tosCroll() {

            const targetElements = this.$refs.targetTops;
            const targetPosition = targetElements.offsetTop
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },
        
        // 客服链接
        live800() {
            window.open(
                this.$parent.live800Url
            );
        },
        // 下载App
        downloadApp() {
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
                try {
                    window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
                } catch (error) {
                    window.open(this.$parent.iosUrl);
                }
            } else { // 安卓
                try {
                    window.android.gotoRegisterReal();
                } catch (error) {
                    window.open(this.$parent.androidUrl);
                }
            }
        },



    },
    deactivated() {
        clearInterval(this.animate)
    },
    beforeDestroy() {
        clearInterval(this.animate)
    },

};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    // overflow-x: hidden;
    // height: 6215px;

    position: relative;
    .tabbar {
        width: 100%;
        padding: 0 10%;
        box-sizing: border-box;
        background-color: #ffffff;
         display: flex;
         align-items: center;
         justify-content: space-between;
        img {
            margin: 20px 50px;
            width: 130px;
        }
        .downloads{
            width: 167px;
            height: 50px;
            border-radius: 20px;
            background: #ff0909;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-weight: 600;
            cursor: pointer;
        } 
    }


    .navBarFixed {
        position: fixed;
        top: 0;
        z-index: 999;
    }

    .banner {
        width: 100%;

        display: block;
    }

    .activity-tit {
        color: #fff;
        font-size: 20px;
        position: absolute;
        top: 38%;
        left: 22%;
        z-index: 10;
    }

    .activitys {
        position: absolute;
        top: 33%;
    }

    .wapbanner {
        width: 100%;
        display: none;
    }

    #login {
        width: 26%;
        height: 12.5vw;
        margin: 0 auto;
        background: url(/activity/Millionsubsidy/submit.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 132px 0 58px;
        position: absolute;
        top: 10vw;
        right: 2%;
        transform: translate(-50%, 0);
        display: block;

        .logxiadan {
            width: 70%;
            margin: 0 auto;
            margin-bottom: 10px;

            img {
                width: 100%;
            }
        }

        .interactive {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            input:focus {
                outline: none;
            }

            input {
                width: 80%;
                height: 3vw;
                background: #fff4e5;
                border: 1px solid #fff;
                border-radius: 10px;
                font-size: 16px;
                text-indent: 25px;
                list-style: none;
                border: 1px solid #fff4e5;
                // color: #ffb180;
            }

            .codeBox {
                width: 80%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 16px 0 26px 0;

                input {
                    width: 100%;
                }

                span {
                    width: 160px;
                    height: 3vw;
                    line-height: 3vw;
                    font-size: 16px;
                    border-radius: 10px;
                    background: linear-gradient(to bottom, #ffefcc, #ffc994);
                    width: 142px;

                    background: #ff1220;

                    text-align: center;
                    color: #fff;
                    position: absolute;
                    top: 0vw;
                    right: 0px;
                    cursor: pointer;
                }
            }

            .loginBtn {
                width: 20%;
                cursor: pointer;
                position: relative;
                top: 15px;
            }
        }

        .codeDialog {
            width: 500px;
            height: 250px;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #fee6e4;
            border-radius: 15px;
            z-index: 99;
            border: 1px solid #ffdbdb;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            img {
                width: 120px;
                margin-bottom: 0;
            }

            p {
                span {
                    color: #5f0e15;
                    font-size: 18px;
                    font-weight: 600;
                }

                input {
                    width: 150px;
                    height: 30px;
                    background-color: #ffffff;
                    border: none;
                    margin-left: 10px;
                    text-indent: 10px;
                    color: #5f0e15;
                    font-size: 16px;
                }
            }

            div {
                display: flex;
                justify-content: center;
                align-items: center;

                button {
                    width: 100px;
                    height: 40px;
                    border: 1px solid #f64b44;
                    background-color: #ffffff;
                    color: #f64b44;
                    font-size: 18px;
                    border-radius: 8px;
                    margin: 0 10px;
                }

                button:nth-child(2) {
                    background-color: #f64b44;
                    color: #ffffff;
                }
            }
        }

        .buttom {
            width: 240px;
            height: 54px;
            margin: 0 auto;

        }

    }

    .waplogin {
        width: 96%;
        height: auto;
        margin: 0 auto;
        background: url(/activity/Millionsubsidy/wap/submit.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 26% 20px 20px;
        position: absolute;
        top: 14%;
        right: 2%;
        left: 2%;
        box-sizing: border-box;

        display: none;


        .interactive {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;

            input:focus {
                outline: none;
            }

            input {
                width: 90%;
                height: 40px;
                background: #fff4e5;
                border: 1px solid #fff;
                border-radius: 10px;
                font-size: 16px;
                text-indent: 25px;
                list-style: none;
                border: 1px solid #fff4e5;
                // color: #ffb180;
            }

            .codeBox {
                width: 90%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 16px 0 26px 0;

                input {
                    width: 100%;
                }

                span {
                    width: 120px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;
                    border-radius: 10px;
                    background: linear-gradient(to bottom, #ffefcc, #ffc994);
                    width: 122px;

                    background: #ff1220;

                    text-align: center;
                    color: #fff;
                    position: absolute;
                    top: 0vw;
                    right: 0px;
                    cursor: pointer;
                }
            }

            .loginBtn {
                width: 20%;
                cursor: pointer;
                position: relative;
                top: 15px;
            }
        }

        .codeDialog {
            width: 500px;
            height: 250px;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background-color: #fee6e4;
            border-radius: 15px;
            z-index: 99;
            border: 1px solid #ffdbdb;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;

            img {
                width: 120px;
                margin-bottom: 0;
            }

            p {
                span {
                    color: #5f0e15;
                    font-size: 18px;
                    font-weight: 600;
                }

                input {
                    width: 150px;
                    height: 30px;
                    background-color: #ffffff;
                    border: none;
                    margin-left: 10px;
                    text-indent: 10px;
                    color: #5f0e15;
                    font-size: 16px;
                }
            }

            div {
                display: flex;
                justify-content: center;
                align-items: center;

                button {
                    width: 100px;
                    height: 40px;
                    border: 1px solid #f64b44;
                    background-color: #ffffff;
                    color: #f64b44;
                    font-size: 18px;
                    border-radius: 8px;
                    margin: 0 10px;
                }

                button:nth-child(2) {
                    background-color: #f64b44;
                    color: #ffffff;
                }
            }
        }

        .buttom {
            width: 80%;
            height: auto;
            margin: 0 auto;

            img {
                width: 100%;
                height: 100%;
            }

        }

    }

    .waplogins {
        position: absolute;
        top: 66%;
        right: 2%;
    }

    .logins {
        position: absolute;
        top: 12%;
    }




    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;
        position: absolute;
        top: 46vw;
        background-size: 100% 90%;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1)10%, #F8E8C8 11%, #F8E8C8 100%);
        display: block;


        .part {
            // max-width: 1400px;

            margin: 0 auto;
            padding: 0% 15% 10% 17%;
            background: url(/activity/Millionsubsidy/bg.png) no-repeat;
            background-size: 100% 100%;

            .part1 {
                width: 100%;
                margin: 0 auto;
                position: relative;

                .rule {
                    position: absolute;
                    top: 18%;
                    right: 12%;
                }

            }

            .part1-buttom,
            .part2-buttom {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 40px;
                cursor: pointer;
            }

            .request {
                margin-right: 20px;
            }

            .part2 {
                position: relative;
                max-width: 1377px;

                margin: 0 auto;
                margin-top: 155px;

                .rule {
                    position: absolute;
                    top: 12%;
                    right: 12%;
                }


            }

            .part3 {
                max-width: 1377px;
                // width: 1377px;
                // height: 1718px;
                margin: 0 auto;
                margin-top: 100px;

                margin-bottom: 90px;

                padding-bottom: 30px;


            }
        }
    }

    .wapcontent {
        display: none;
        width: 100%;
        height: auto;

        background: red;
        margin: 0 auto;
        padding-top: 70%;
        background: url(/activity/Millionsubsidy/wap/bg.png) no-repeat;
        background-size: 100% 100%;

        .part {
            // max-width: 1400px;
            width: 100%;
            box-sizing: border-box;
            margin: 0 auto;
            padding: 0 20px;


            .part1 {
                width: 100%;
                margin: 0 auto;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                }

                .rule {
                    position: absolute;
                    top: 14%;
                    left: 40%;
                    width: 24%;
                    height: auto;
                }

            }

            .part1-buttom,
            .part2-buttom {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;

                img {
                    width: 47%;
                    height: auto;
                }
            }

            .part2-tit {
                width: 80%;
            }

            .request {
                margin-right: 20px;
            }

            .part2 {
                position: relative;
                width: 100%;
                margin: 0 auto;
                margin-top: 60px;

                img {
                    width: 100%;
                    height: 100%;
                }

                .rule {
                    position: absolute;
                    top: 5%;
                    left: 34%;
                    width: 24%;
                    height: auto;
                }


            }

            .part3 {
                width: 100%;
                margin: 0 auto;
                margin-top: 60px;

                margin-bottom: 90px;

                padding-bottom: 30px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .closer {
        width: 25px;
        height: auto;
        position: fixed;
        top: 0%;
        right: 0;
        cursor: pointer;

        z-index: 9999;
    }



    .dark {
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.5;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 101;
    }

    .loginDialogs {
        .closer {
            position: absolute;
            top: 40px;
            right: 0px;
            width: 50px;
            height: 50px;
        }

        position: relative;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        /deep/ .el-dialog__body {
            background: rgba(0, 0, 0, 0.5);

            border: none !important;
            width: 332px !important;
            height: 150px !important;
        }

        .conts {
            width: 300px;
            height: 96px;
            background: #fff1df;
            border-radius: 10px;
            position: absolute;
            bottom: 30%;
            right: 26%;
            z-index: 99;
            color: #000;
            font-weight: 600;
            line-height: 30px;
            font-size: 24px;
            text-align: center;
            padding-top: 20px;
            box-sizing: border-box;
        }

        .buttoms {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 8%;
            bottom: 10%;
            width: 80%;
            cursor: pointer;

            img:nth-child(1) {
                margin-right: 20px;
            }

            img {
                width: 40%;
                height: auto;
            }
        }



    }

    .loginDialogs1 {
        .closer {
            position: absolute;
            top: -22px;
            right: 15%;
            width: 30px;
            height: 30px;
        }

        position: relative;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .dialogContent {
            box-sizing: border-box;
            padding: 10% 40px;

            overflow-y: scroll;
            width: 60%;
            height: 880px;
            background: url(/activity/Millionsubsidy/rulebg.png) no-repeat;
            background-size: 100% 100%;

            h3 {
                color: #d88f4f;
                text-align: center;

            }

            li {
                font-size: 16px;
                color: #464646;
                line-height: 34px;

                span {
                    font-weight: 600;
                    color: #ff7e50;
                }

                .example {
                    color: #1665f5;
                    font-weight: 600;
                }

                .font {
                    color: #000;
                    font-weight: 600;
                }

                img {
                    width: 100%;
                    height: auto;
                    margin: 20px 0;
                }

                table {
                    margin: 20px 0;
                    width: 100%;
                    border: 1px solid #464646;
                    border-radius: 10px;

                    tr {
                        th {
                            text-align: center;
                            font-weight: 500;
                            line-height: 24px;
                            border-bottom: 1px solid #464646;
                            border-right: 1px solid #464646;
                            padding: 5px;
                        }

                        th:last-child {}
                    }

                    tr:nth-child(1) {
                        th {
                            font-weight: 600;
                        }
                    }
                }
            }
        }

        &::-webkit-scrollbar {
            width: 0px;
        }

        .dialogContent::-webkit-scrollbar {
            display: none;
        }
    }
}


@media screen and (max-width: 500px) {
    .box {
        .tabbar {
                width: 100%;
                padding: 0 5%;
                box-sizing: border-box;
                background-color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: space-between;
        
                img {
                    margin: 20px 0px;
                    width: 100px;
                }
        
                .downloads {
                    width: 83px;
                    height: 30px;
                    border-radius: 20px;
                    background: #ff0909;
                    text-align: center;
                    line-height: 30px;
                    color: #fff;
                    font-weight: 600;
                    cursor: pointer;
                    font-size: 12px;
                }
            }
        .banner {
            display: none;
        }

        .wapbanner {
            display: block;
        }

        .content {
            display: none;
        }

        .wapcontent {
            display: block;
        }

        #login {
            display: none;
        }

        .waplogin {
            display: block;
        }
        .waplogin1{
            position: absolute;
            top: 12%;
        }
        .loginDialogs {
            .closer {
                position: absolute;
                top: 40px;
                right: 22px;
                width: 30px;
                height: 30px;
            }

            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .success {
                width: 400px;
                height: auto;
            }

            /deep/ .el-dialog__body {
                background: rgba(0, 0, 0, 0.5);

                border: none !important;
                width: 332px !important;
                height: 150px !important;
            }

            .conts {
                width: 200px;
                height: 55px;
                background: #fff1df;
                border-radius: 10px;
                position: absolute;
                bottom: 31%;
                right: 26%;

                z-index: 99;
                color: #000;
                font-weight: 600;
                line-height: 18px;
                font-size: 14px;
                text-align: center;
                padding-top: 10px;
                box-sizing: border-box;
            }

            .buttoms {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: 8%;
                bottom: 10%;
                width: 80%;
                cursor: pointer;

                img:nth-child(1) {
                    margin-right: 20px;
                }

                img {
                    width: 40%;
                    height: auto;
                }
            }



        }

        .loginDialogs1 {
            .closer {
                position: absolute;
                top: -22px;
                right: -30px;
                width: 30px;
                height: 30px;
            }

            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .dialogContent {
                box-sizing: border-box;
                padding: 10% 20px;

                overflow-y: scroll;
                width: 300px;
                height: 580px;
                background: url(/activity/Millionsubsidy/rulebg.png) no-repeat;
                background-size: 100% 100%;

                h3 {
                    color: #d88f4f;
                    text-align: center;
                    font-size: 12px;
                }

                li {
                    font-size: 12px;
                    color: #464646;
                    line-height: 34px;

                    span {
                        font-weight: 600;
                        color: #ff7e50;
                    }

                    .example {
                        color: #1665f5;
                        font-weight: 600;
                    }

                    .font {
                        color: #000;
                        font-weight: 600;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }

                    table {
                        margin: 20px 0;
                        width: 100%;
                        border: 1px solid #464646;
                        border-radius: 10px;

                        tr {
                            th {
                                text-align: center;
                                font-weight: 500;
                                line-height: 24px;
                                border-bottom: 1px solid #464646;
                                border-right: 1px solid #464646;
                                padding: 5px;
                            }

                            th:last-child {}
                        }

                        tr:nth-child(1) {
                            th {
                                font-weight: 600;
                            }
                        }
                    }
                }
            }

            &::-webkit-scrollbar {
                width: 0px;
            }

            .dialogContent::-webkit-scrollbar {
                display: none;
            }
        }

        .activity-tit {
            color: #fff;
            font-size: 14px;
            position: absolute;
            top: 7.3%;
            left: 24%;
            z-index: 10;
        }
        .titss{
            position: absolute;
            top: 5.5%;
        }
        .activitys {
            position: absolute;
            top: 5.5%;
        }

        .wapcontent .part .part1 .rule {
            position: absolute;
            top: 9%;
        }

        .wapcontent .part .part2 .rule {
            position: absolute;
            top: 4.5%;
        }
    }
}

//--------------------------110----------------------
@media screen and (min-width: 1741px) and (max-width: 1897px) {
    .box .loginDialogs1 .dialogContent {
        height: 780px;
    }
}

// ---------------125%------------------
@media screen and (min-width: 1517px) and (max-width: 1741px) {
    .box {
        #login {
            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }
        }

        .content {
            .part {

                .part1 img,
                .part2 img,
                .part3 img {
                    width: 100%;
                }

                .part1 .rule {
                    position: absolute;
                    right: 8%;
                }

                .part2 .rule {
                    position: absolute;
                    right: 9%;
                }
            }
        }

        .loginDialogs1 .dialogContent {
            height: 700px;
        }

        .activity-tit {
            position: absolute;
            top: 39%;
        }

        .activitys {
            position: absolute;
            top: 33%;
        }
    }
}

// -------------------150%--------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {
    .box {
        #login {
            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }

            .interactive {
                .codeBox {
                    span {
                        width: 122px;
                    }
                }
            }
        }

        .content {
            .part {

                .part1 img,
                .part2 img,
                .part3 img {
                    width: 100%;
                }

                .part1 .rule {
                    position: absolute;
                    right: 8%;
                }

                .part2 .rule {
                    position: absolute;
                    right: 9%;
                }
            }
        }

        .loginDialogs1 .dialogContent {
            height: 580px;
        }

        .activity-tit {
            position: absolute;
            top: 41%;
            left: 20%;
        }

        .activitys {
            position: absolute;
            top: 32%;
        }
    }
}
</style>